import './../../Font/font.css';
import { Progress, Form } from 'antd';

import StepWizard from 'react-step-wizard';
import moment from 'moment';
import classNames from 'classnames';
//Step Form
import Step1 from './Stap1';
import Step2 from './Stap2';
import Step3 from './Stap3';
import Step4 from './Stap4';
import Step5 from './Stap5';
import { useState } from 'react';

const { Provider } = Form;

const DsFormStep = ({
    platform,
    submitData,
    applicantInformation,
    personalInformation,
    detailsOfClaim,
    evidenceInformation,
    policyAndTermsOfService,
    customForm,
    customStyle,
    fontStyle,
    logo,
    companyLogo,
    lang,
    setPageChange,
    reset,
    setReset,
    personalTypeList,
    requestType,
}) => {
    //List

    const [state, updateState] = useState();
    const [currentProgress, setCurrentProgress] = useState(0);

    const onFormFinish = (name, info) => {
        setPageChange(false);
        // navigate(`/thank-you-page/${'en'}`);
    };

    const getPersonalType = () => {
        if (personalInformation.getFieldValue('personalType') === undefined) {
            personalInformation?.setFieldsValue({
                personalType: personalTypeList[0]?.id,
            });
        }
    };

    const getFont = () => {
        return fontStyle?.fontFamily;
    };

    const termAndPrivacy = (customForm, color) => {
        const URLID = customForm?.privacyPolicyUrlId;
        let URL1 = customForm?.termConditionUrl;
        let URL2 = URLID
            ? `${window.location.origin}/external-privacy?id=${URLID}&lang=TH`
            : customForm?.privacyPolicyUrl;
        if (URL1 && URL2) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL1)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                    >
                        {'Term & Condition'}
                    </button>{' '}
                    &{' '}
                    <button
                        type="button"
                        onClick={() => window.open(URL2)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Privacy Policy'}
                    </button>
                </div>
            );
        } else if (URL1) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL1)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Term & Condition'}
                    </button>
                </div>
            );
        } else if (URL2) {
            return (
                <div
                    style={{
                        color: color,
                        textDecorationColor: color,
                    }}
                >
                    <button
                        type="button"
                        onClick={() => window.open(URL2)}
                        className="cursor-pointer underline decoration-solid decoration-1 underline-offset-2 duration-150 hover:opacity-50"
                        style={{
                            color: color,
                            textDecorationColor: color,
                        }}
                    >
                        {'Privacy Policy'}
                    </button>
                </div>
            );
        } else {
            return <></>;
        }
    };

    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });

    return (
        <div className={getFont()}>
            <div
                className={classNames('mx-auto pt-8 pb-5', {
                    'w-[85%]': platform === 'Desktop',
                    'w-full': platform === 'Tablet',
                    'w-[100%]': platform === 'Mobile',
                })}
            >
                <div
                    className={classNames('space-y-3', {
                        'px-8': platform === 'Tablet',
                        'px-3': platform === 'Mobile',
                    })}
                >
                    <div
                        className={classNames(
                            'justify-between flex items-center',
                            {
                                flex: platform === 'Tablet',
                                'grid grid-cols-1': platform === 'Mobile',
                            }
                        )}
                        style={{ color: fontStyle?.textTitleColor }}
                    >
                        <div
                            className={classNames(
                                'text-xl font-medium',
                                {
                                    'basis-4/6': platform === 'Desktop',
                                },
                                {
                                    'basis-4/6': platform === 'Tablet',
                                },
                                {
                                    'basis-full': platform === 'Mobile',
                                }
                            )}
                            // className="sm:basis-full md:basis-4/6 text-xl font-bold"
                        >
                            Data Subject Rights Request Form
                        </div>
                        <div
                            className={classNames(
                                'text-xs font-medium',
                                {
                                    'basis-2/6 text-right':
                                        platform === 'Desktop',
                                },
                                {
                                    'basis-2/6 text-right':
                                        platform === 'Tablet',
                                },
                                {
                                    'basis-full text-left':
                                        platform === 'Mobile',
                                }
                            )}
                            // className="sm:basis-full md:basis-2/6 sm:text-left md:text-right text-xs font-medium"
                        >
                            {lang === 'TH' ? 'วันที่ส่งคำขอ' : 'Request date'}{' '}
                            {moment(new Date()).format('DD/MM/YYYY')}
                        </div>
                    </div>

                    <div
                        className={classNames(
                            'bg-white rounded-md p-4 font-semibold text-base',
                            {
                                'md:flex md:space-x-3': platform === 'Desktop',
                                'flex space-x-3': platform === 'Tablet',
                                'grid grid-cols-1': platform === 'Mobile',
                            }
                        )}
                        // className="bg-white rounded-md p-4 sm:grid sm:grid-cols-1 md:flex md:space-x-3 font-semibold text-base"
                    >
                        <div
                            className={classNames(
                                '-mt-0.5',
                                {
                                    'basis-8/12': platform === 'Desktop',
                                },
                                {
                                    'basis-7/12': platform === 'Tablet',
                                },
                                {
                                    'basis-7/12': platform === 'Desktop',
                                }
                            )}
                            // 2xl:basis-8/12
                            // xl:basis-7/12
                            // lg:basis-6/12
                            // md:basis-7/12
                            // className="-mt-0.5 md:basis-7/12 lg:basis-6/12 xl:basis-7/12 2xl:basis-8/12 "
                        >
                            <Progress
                                strokeColor={{
                                    '0%': '#4ACE8F',
                                    '100%': '#4ACE8F',
                                }}
                                percent={currentProgress}
                                status="active"
                                showInfo={false}
                            />
                        </div>
                        <div
                            className={classNames(
                                {
                                    'basis-4/12': platform === 'Desktop',
                                },
                                {
                                    'basis-5/12': platform === 'Tablet',
                                },
                                {
                                    'basis-5/12': platform === 'Mobile',
                                }
                            )}
                            // className="md:basis-5/12 lg:basis-6/12 xl:basis-5/12 2xl:basis-4/12 "
                        >
                            <span
                                className={`pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}%{' '}
                                {lang === 'TH' ? 'สำเร็จ' : 'Succeed'}
                            </span>
                            <span className="sm:text-left md:text-right">
                                {lang === 'TH'
                                    ? 'คุณกรอกข้อมูลเรียบร้อยแล้ว'
                                    : 'Filled Information'}
                            </span>
                        </div>
                    </div>
                    {/* DS Request Form */}
                    <Provider onFormFinish={onFormFinish}>
                        <StepWizard
                            instance={setInstance}
                            onStepChange={({ activeStep }) => {
                                if (activeStep === 1) {
                                    setCurrentProgress(0);
                                } else
                                    setCurrentProgress((activeStep - 1) * 20);
                            }}
                        >
                            <Step1
                                setReset={setReset}
                                reset={reset}
                                lang={lang}
                                loading={false}
                                form={applicantInformation}
                                personalInformation={personalInformation}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                getPersonalType={() => getPersonalType()}
                                platform={platform}
                            />
                            <Step2
                                lang={lang}
                                loading={false}
                                form={personalInformation}
                                formStep1={applicantInformation}
                                currentProgress={currentProgress}
                                personalTypeList={personalTypeList}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                platform={platform}
                            />
                            <Step3
                                requestTypeList={requestType}
                                lang={lang}
                                loading={false}
                                form={detailsOfClaim}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                getPersonalType={() => getPersonalType()}
                                platform={platform}
                            />
                            <Step4
                                lang={lang}
                                loading={false}
                                form={evidenceInformation}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                platform={platform}
                            />
                            <Step5
                                lang={lang}
                                step1={applicantInformation}
                                step2={personalInformation}
                                step3={detailsOfClaim}
                                step4={evidenceInformation}
                                loading={false}
                                onFormFinish={onFormFinish}
                                data={submitData}
                                customForm={customForm}
                                customStyle={customStyle}
                                fontStyle={fontStyle}
                                platform={platform}
                            />
                        </StepWizard>
                    </Provider>

                    {/* url logo */}
                    <div className="flex justify-between">
                        <div>
                            {termAndPrivacy(
                                policyAndTermsOfService,
                                fontStyle?.textLinkColor
                            )}
                        </div>
                        <div>
                            {logo?.hiddenLogo && (
                                <img alt="logo" height={20} src={companyLogo} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DsFormStep;
